import React, { useState, useEffect } from 'react';
import './ConsensusOverview.css';

const ConsensusOverview = ({ consensusMetrics = {}, chainData = {} }) => {
  const [metricsData, setMetricsData] = useState(consensusMetrics);

  useEffect(() => {
    setMetricsData(consensusMetrics);
  }, [consensusMetrics]);

  const formatEfficiency = (efficiency) => {
    const percentage = (efficiency * 100).toFixed(2);
    return `${percentage}%`;
  };

  const getEfficiencyStatus = (efficiency) => {
    if (efficiency >= 0.98) return 'status-ok';
    if (efficiency >= 0.95) return 'status-warning';
    return 'status-error';
  };

  const formatEpochProgress = (currentEpoch, duration) => {
    const progressMs = (Date.now() % duration);
    const progressPercent = (progressMs / duration) * 100;
    return progressPercent.toFixed(1);
  };

  return (
    <div className="consensus-overview-minimal">
      <div className="consensus-header-minimal">
        <h3 className="section-title-minimal">Flow Consensus Metrics</h3>
        <div className="consensus-status-minimal">
          <span className={`status-indicator-minimal ${getEfficiencyStatus(metricsData.consensus_efficiency)}`}>
            Flow Consensus Active
          </span>
        </div>
      </div>

      <div className="consensus-grid-minimal">
        <div className="metric-card-consensus">
          <div className="metric-content-consensus">
            <div className="metric-label-consensus">Current Epoch</div>
            <div className="metric-value-consensus">{metricsData.current_epoch || 0}</div>
            <div className="metric-sublabel-consensus">
              Progress: {formatEpochProgress(metricsData.current_epoch, metricsData.epoch_duration)}%
            </div>
          </div>
        </div>

        <div className="metric-card-consensus">
          <div className="metric-content-consensus">
            <div className="metric-label-consensus">Consensus Efficiency</div>
            <div className={`metric-value-consensus ${getEfficiencyStatus(metricsData.consensus_efficiency)}`}>
              {formatEfficiency(metricsData.consensus_efficiency || 0)}
            </div>
            <div className="metric-sublabel-consensus">Flow Algorithm</div>
          </div>
        </div>

        <div className="metric-card-consensus">
          <div className="metric-content-consensus">
            <div className="metric-label-consensus">Validator Count</div>
            <div className="metric-value-consensus">{metricsData.active_validators || 0}</div>
            <div className="metric-sublabel-consensus">Active</div>
          </div>
        </div>

        <div className="metric-card-consensus">
          <div className="metric-content-consensus">
            <div className="metric-label-consensus">Connected Peers</div>
            <div className="metric-value-consensus">{metricsData.connected_peers || 0}</div>
            <div className="metric-sublabel-consensus">Network</div>
          </div>
        </div>
      </div>

      <div className="consensus-details-minimal">
        <div className="detail-section">
          <h4 className="detail-title-minimal">Consensus Health</h4>
          <div className="detail-grid">
            <div className="detail-item">
              <span className="detail-label">Algorithm:</span>
              <span className="detail-value">Flow Consensus</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Status:</span>
              <span className={`detail-value ${getEfficiencyStatus(metricsData.consensus_efficiency)}`}>
                {metricsData.consensus_efficiency >= 0.98 ? 'Optimal' : 
                 metricsData.consensus_efficiency >= 0.95 ? 'Good' : 'Degraded'}
              </span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Last Finalized:</span>
              <span className="detail-value">Block #{chainData.chain?.length || 0}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Network Security:</span>
              <span className="detail-value status-ok">Secured</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsensusOverview;